import SydFilterProvider from "src/components/Common/UI/SydFilter/SydFilterContext";
import SydFilterView from "src/components/Common/UI/SydFilter/SydFilterView";
import SearchUserInspector from "./SearchUserInspector";
import UserInspectorDataView from "./UserInspectorDataView";


const defaultFilterData: IUserInspectorSearchForm = {
  datetimeFrom: "",
  datetimeTo: "",
  username: ""
}

const UserInspector = () => {
  return (
    <div className="page-content">
      <div className="text-center">
          <span className="h1">Κινήσεις Χρηστών</span>
        </div>
      <SydFilterProvider
        defaultFilterData={defaultFilterData}
      >
        <SydFilterView  title="Αναζήτηση Κίνησης">
          <SearchUserInspector />
        </SydFilterView>

        <UserInspectorDataView />
      </SydFilterProvider>
    </div>
  )
}

export default UserInspector;